'use client';

import SearchBar from 'components/controls/search-bar';
import { useRouter } from 'src/navigation';
import { useState } from 'react';
import { routes } from '@metmuseum/routes';
import { trackCollectionSearchSubmitted } from 'lib/analytics/trackSearch';

const CollectionLandingPageSearchWrapper = () => {
	const [query, setQuery] = useState(null);
	const [isSearching, setIsSearching] = useState(false);
	const router = useRouter();

	const handleSearch = () => {
		setIsSearching(true);
		trackCollectionSearchSubmitted({
			searchOrigin: 'Collection Landing',
			searchTerm: query,
		});
		query
			? router.push(routes.advancedCollectionSearch({ q: query }))
			: router.push(routes.advancedCollectionSearch());
	};

	return (
		<SearchBar
			debounceTimeout={0}
			placeholderText="Search by artist, title, date, object number, and more"
			onKeyDown={(event) => event.key === 'Enter' && handleSearch()}
			onChange={(event) => setQuery(event.target.value)}
			isSearching={isSearching}
			onButtonClick={handleSearch}
		/>
	);
};

export default CollectionLandingPageSearchWrapper;
